import $ from 'jquery';

export default class {
	constructor(options, cb) {
		const defaults = {
			el: '.js-counter',
			dom: {
				input: '.js-counter-input',
				plus: '.js-counter-plus',
				minus: '.js-counter-minus'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);

		this.callback = cb;
	}

	getDom() {
		this.$input = this.$el.find(this.options.dom.input);
		this.$plus = this.$el.find(this.options.dom.plus);
		this.$minus = this.$el.find(this.options.dom.minus);
		return this;
	}

	checkValue(value, maxValue) {
		if (value < 1) {
			value = 1;
		}
		if (value > maxValue) {
			value = maxValue;
		}
		return value;
	}

	setButtonAbility($el, maxValue) {
		const $input = $el.find(this.options.dom.input);
		const $plus = $el.find(this.options.dom.plus);
		const $minus = $el.find(this.options.dom.minus);
		const value = Number($input.val());

		if (maxValue === 1) {
			$minus.prop('disabled', true);
			$plus.prop('disabled', true);
			$input.css('pointer-events', 'none');
		} else if (value === 1) {
			$minus.prop('disabled', true);
			$plus.prop('disabled', false);
		} else if (value === maxValue) {
			$minus.prop('disabled', false);
			$plus.prop('disabled', true);
		} else {
			$minus.prop('disabled', false);
			$plus.prop('disabled', false);
		}
	}

	changeValue(difference, e) {
		const $target = $(e.currentTarget);
		const $el = $target.parent(this.$el);
		const $input = $el.find(this.options.dom.input);
		const maxValue = Number($input.data('max'));
		const value = this.checkValue(Number($input.val()) + difference, maxValue);
		$input.val(value);
		this.setButtonAbility($el, maxValue);
		this.callback();
	}

	handleChange(e) {
		const $target = $(e.currentTarget);
		const $el = $target.parent(this.$el);
		const $input = $el.find(this.options.dom.input);
		let value = Number($input.val());
		const maxValue = Number($input.data('max'));
		if (!isNaN(value)) {
			value = this.checkValue(value, maxValue);
			$input.val(value);
			this.setButtonAbility($el, maxValue);
		} else {
			$input.val(1);
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$plus.on('click', this.changeValue.bind(this, +1));
			this.$minus.on('click', this.changeValue.bind(this, -1));
			this.$input.on('change', this.handleChange.bind(this));
			this.$el.each((i, elem) => {
				const $el = $(elem);
				const $input = $el.find(this.options.dom.input);
				const maxValue = Number($input.data('max'));
				this.setButtonAbility($el, maxValue);
			});
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/counter/counter.js
 **/